<template>
  <div class="error-container">
    <slot v-if="err" name="error" :err="err" :vm="vm" :info="info"
      >Something went wrong</slot
    >
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'error-boundary',
  props: {
    stopPropagation: Boolean
  },
  data() {
    return {
      err: false,
      vm: null,
      info: null
    }
  },
  errorCaptured(err, vm, info) {
    this.err = err
    this.vm = vm
    this.info = info
    return !this.stopPropagation
  }
}
</script>

<style scoped>
.error-container {
  min-height: 100vh;
  display: flex;
  position: relative;
  background: white;
  margin-top: -4rem;
}
</style>
